import _Cascader from "antd/es/cascader";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import LocChoice from '../../common/Question/LocChoice';
import { getLocalText } from '@/utilities/language';
import IconFont from '@/components/common/IconFont';
var FormItem = _Form.Item;
var LocChoicePC = /*#__PURE__*/function (_Component) {
  _inherits(LocChoicePC, _Component);
  function LocChoicePC() {
    _classCallCheck(this, LocChoicePC);
    return _possibleConstructorReturn(this, _getPrototypeOf(LocChoicePC).apply(this, arguments));
  }
  _createClass(LocChoicePC, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        question = _this$props.question;
      return React.createElement(LocChoice, this.props, function (_ref) {
        var error = _ref.error,
          formAnswer = _ref.formAnswer,
          _onChange = _ref.onChange,
          options = _ref.options;
        return React.createElement(FormItem, {
          label: label,
          validateStatus: error ? 'error' : null,
          hasFeedback: true,
          help: error,
          required: question.required
        }, React.createElement(_Cascader, {
          showSearch: true,
          allowClear: false,
          value: formAnswer.location,
          placeholder: getLocalText('mobile.selected'),
          onChange: function onChange(location) {
            return _onChange(location);
          },
          options: options,
          suffixIcon: React.createElement("span", {
            style: {
              fontSize: 12
            }
          }, React.createElement(IconFont, {
            type: "icon-zhankai"
          }))
        }));
      });
    }
  }]);
  return LocChoicePC;
}(Component);
export { LocChoicePC as default };